// <group-id-to-name id='{{task.assignedGroup.id}}'></group-id-to-name>

function directive($q, $log, groupsService) {
  function link($scope, element, attrs) {
    const scope = $scope;
    // this pulls the 'id' attribute in for use in the template
    attrs.$observe('id', (id) => {
      groupsService.convertIdToName(id)
        .then((data) => {
          scope.groupName = data;
        }, (response) => {
          $log.error('groupIdToName error: ', response);
        });
    });
  }

  return {
    link,
    restrict: 'E',
    scope: {},
    template: '{{groupName}}'
  };
}

const dirArray = [
  '$q',
  '$log',
  'groupsService',
  directive
];

export default function (ngModule) {
  ngModule.directive('groupIdToName', dirArray);
}
